import { createSlice } from '@reduxjs/toolkit';
import { THEME_CONFIG } from 'configs/AppConfig';

export const initialState = THEME_CONFIG;

export const themeSlice = createSlice({
  initialState,
  name: 'theme',
  reducers: {
    onLocaleChange: (state, action) => {
      state.locale = action.payload;
    },
    onNavTypeChange: (state, action) => {
      state.navType = action.payload;
    },
    onBlankLayout: (state, action) => {
      state.blankLayout = action.payload;
    },
    onSwitchTheme: (state, action) => {
      state.currentTheme = action.payload;
    },
    onMobileNavToggle: (state, action) => {
      state.mobileNav = action.payload;
    },
    onDirectionChange: (state, action) => {
      state.direction = action.payload;
    },
    onNavStyleChange: (state, action) => {
      state.sideNavTheme = action.payload;
    },
    toggleCollapsedNav: (state, action) => {
      state.navCollapsed = action.payload;
    },
    onTopNavColorChange: (state, action) => {
      state.topNavColor = action.payload;
    },
    onHeaderNavColorChange: (state, action) => {
      state.headerNavColor = action.payload;
    },
  },
});

export const {
  onSwitchTheme,
  onBlankLayout,
  onLocaleChange,
  onNavTypeChange,
  onNavStyleChange,
  onMobileNavToggle,
  onDirectionChange,
  toggleCollapsedNav,
  onTopNavColorChange,
  onHeaderNavColorChange,
} = themeSlice.actions;

export default themeSlice.reducer;
